import { defineWave } from '../schema';

/** BLOC D3 — LE RAPPEL. Quatorze secondes pour finir en action, pas dans le vide.
 *
 *  Sa seule fonction est de tenir le joueur occupé jusqu'au silence d'avant-boss
 *  sans rien introduire de neuf. Il rappelle le couple Rôdeur + Dard, c'est-à-
 *  dire la géographie stable et la rupture, qui est la formule la plus lisible
 *  du monde.
 *
 *  ⚠️ Dernier spawn à 6 s pour une durée de 14 s. Ces huit secondes de queue ne
 *  sont pas du gaspillage : elles laissent aux traînards le temps de mourir ou
 *  de sortir du cadre AVANT que le bloc de boss ne commence. Le silence de cinq
 *  secondes qui ouvre `boss-navette` ne garantit qu'une chose — qu'aucun ennemi
 *  n'APPARAÎT. Que l'écran soit vide se joue ici, et nulle part ailleurs. */
export default defineWave({
  id: 'd3-rappel',
  duration: 14,
  spawns: [
    { at: 0.5, enemy: 'rodeur', lane: 2, count: 1, spacing: 0 },
    { at: 0.9, enemy: 'rodeur', lane: 4, count: 1, spacing: 0 },
    { at: 3.0, enemy: 'dard', lane: 3, count: 4, spacing: 0.45 },
    { at: 6.0, enemy: 'mite', lane: 3, count: 8, spacing: 0.07 },
  ],
});
